import React from "react";
import { GetCreatorsArr, GetRegistryArr } from "./ContentRegistry"
import "./SelectNewContentItem.scss";


export const fallbackSvgPath = "M15.5 3.70766377449036L8.25 6.60766410827637L8.25 15.335789680481L15 12.9389142990112C15.3000001907349 12.8326644897461 15.5 12.5514144897461 15.5 12.2326641082764L15.5 3.70766377449036zM0.500000059604645 3.70766377449036L0.500000059604645 12.2326641082764C0.500000059604645 12.5514144897461 0.700000047683716 12.8326644897461 0.999062597751617 12.9389142990112L7.75 15.335789680481L7.75 6.60766410827637L0.500000059604645 3.70766377449036zM7.72187519073486 0.543289244174957L0.999062597751617 2.93828892707825C0.845625042915344 2.99266409873962 0.718437552452087 3.06703901290894 0.63093763589859 3.22328877449036L8 6.17016410827637L15.3687496185303 3.22328877449036C15.28125 3.06703901290894 15.1531248092651 2.99266409873962 15 2.93828892707825L8.25 0.543289244174957C8.08749961853027 0.485476613044739 7.91249990463257 0.485476613044739 7.72187519073486 0.543289244174957zM7.58125019073486 0.0719767138361931C7.85312509536743 -0.0239921323955059 8.14687538146973 -0.0239921323955059 8.41874980926514 0.0719767138361931L15.1687498092651 2.46703886985779C15.4171867370605 2.55563282966614 15.625 2.71813273429871 15.7707023620605 2.92449975013733C15.9164066314697 3.13086724281311 16 3.38110136985779 16 3.64516377449036L16 12.2326641082764C16 12.4967260360718 15.9164066314697 12.7467260360718 15.7707023620605 12.952977180481C15.625 13.1592264175415 15.4171867370605 13.3217267990112 15.1687498092651 13.4107894897461L8.41874980926514 15.804539680481C8.14687538146973 15.9014139175415 7.85312509536743 15.9014139175415 7.58125019073486 15.804539680481L0.831875145435333 13.4107894897461C0.582500040531158 13.3217267990112 0.374531328678131 13.1592264175415 0.228906437754631 12.952977180481C0.0832813009619713 12.7467260360718 5.00000005843049E-08 12.4967260360718 5.00000005843049E-08 12.2326641082764L5.00000005843049E-08 3.64516377449036C5.00000005843049E-08 3.38110136985779 0.0832813009619713 3.13086724281311 0.228906437754631 2.92449975013733C0.374531328678131 2.71813273429871 0.582500040531158 2.55563282966614 0.831875145435333 2.46703886985779L7.58125019073486 0.0719767138361931z";


export const SelectNewContentItem = (props) => {

    //const entries = GetRegistryArr();
    const entries = GetCreatorsArr();
    const groups = [];
    const groupsDict = {};
    for( let entry of entries ){

        let group = groupsDict[entry.categoryLabel];
        if( !group ){
            group = {
                id: entry.categoryLabel,
                label: entry.categoryLabel,
                entries: []
            }
            groupsDict[group.id] = group;
            groups.push(group);
        }
        group.entries.push(entry);
    }

    return <div className="select-new-content-item">
        {groups.map(group =>
            <div key={group.id} className="item-group">
                <div className="title">
                    {group.label}
                </div>
                <div className="items">
                    {group.entries
                        .filter(entry => !entry.hide)
                        .map((entry, idx) => {

                            const svgPath = entry.svgPath || fallbackSvgPath;
                            const glyph = <svg height={20} width={20} viewBox="0 0 16 16">
                                {svgPath && <path d={svgPath} fillRule="evenodd" fill={entry.svgPath ? "#606060" : "#cfcfcf"} />}
                            </svg>;

                            return <div key={idx} className="menu-item" onClick={() => props.onClick?.(entry)}>
                                <span className="glyph">
                                    {glyph}
                                </span>
                                <span className="label">
                                    {entry.desc_label || entry.label}
                                </span>
                            </div>
                        })
                    }
                </div>
            </div>
        )}
    </div>
}